import type { NavItemDataProps } from '@/layouts/main/nav/types';

import { CookieConsent } from '@/components/CookieConsent';
import { Snackbar } from '@mui/material';
import { Suspense, useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { MenuItem } from './types';

import { SplashScreen } from './components/loading-screen';
import { ProgressBar } from './components/progress-bar';
import { SettingsDrawer } from './components/settings/drawer';
import { MainLayout } from './layouts/main';
import { appMenus } from './store/reducerApp';
import { defaultThemeConfigs, defaultDisplayConfigs } from './store/reducerSettings';

function convertMenuItemToNavItem(menuItem: MenuItem): NavItemDataProps {
  return {
    path: menuItem.uri,
    title: menuItem.label,
    children: menuItem.childItems?.length
      ? menuItem.childItems?.map((child) => ({
          title: child.label,
          path: child.uri,
        }))
      : undefined,
  };
}

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const menuItems = useSelector(appMenus);

  const formatedMenu = useMemo(() => {
    const menus: NavItemDataProps[] = [];
    menuItems?.forEach((item) => menus.push(convertMenuItemToNavItem(item)));
    return {
      nav: {
        data: menus,
      },
    };
  }, [menuItems]);

  return (
    <>
      <Snackbar />
      <ProgressBar />
      <SettingsDrawer
        defaultThemeSettings={defaultThemeConfigs}
        defaultDisplaySettings={defaultDisplayConfigs}
      />
      <Suspense fallback={<SplashScreen />}>
        <MainLayout slotProps={formatedMenu}>{children}</MainLayout>
      </Suspense>
      {/* <CookieConsent /> */}
    </>
  );
};

export default AppLayout;
